import { generateYearsInUkList } from 'directFlow/utils'

import { IsoDateFormat } from 'types'
import { convertIsoDateIntoDateObj } from 'utils/date'
import { capitalize } from 'utils/general'

export const resolveYearsInUk = ({
  dateOfBirth,
  bornInUk,
  yearsInUk,
}: {
  dateOfBirth: IsoDateFormat
  bornInUk: boolean | null
  yearsInUk: number | null
}): string | undefined => {
  const yearsInUkList = generateYearsInUkList(convertIsoDateIntoDateObj(dateOfBirth))

  if (bornInUk) {
    return 'Since birth'
  }

  if (yearsInUk === null) {
    return undefined
  }

  const maxYear = Number(yearsInUkList[yearsInUkList.length - 1].value)

  return yearsInUk < maxYear ? String(yearsInUk) : String(maxYear)
}

export const booleanToDisplay = (value: boolean | undefined) => (value ? 'Yes' : 'No')

export const enumToDisplay = (value: string) => capitalize(value).replace('_', ' ')

type Formatter<T> = (value: T) => string

export const valueToDisplay = <T>({
  value,
  format,
}: {
  value: T | undefined
  format?: Formatter<T>
}): string => {
  if (value === undefined || value === null) {
    return '-'
  }

  return format ? format(value) : String(value)
}
